module.exports = __webpack_public_path__ + "img/Distribution-of-Packages-by-Continent.7c33bcdb.png";